module.exports = __webpack_public_path__ + "static/img/gaozhongyuwen2.573252c0.jpg";